import Slider, { DEFAULT_OPTIONS } from 'CoreComponents/slider';

document.querySelectorAll(DEFAULT_OPTIONS['selector']['slider']).forEach(slider => {
  new Slider(slider);
});



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/initializers/slider.js